import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

interface Result {
  isActivitiesCustomer: boolean;
}

const FEATURE_FLAG_NAME = 'qantas-activities-customer';

const useActivitiesCustomer = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false } = decision || {};

  return {
    isActivitiesCustomer: enabled && isReady,
  };
};

export default useActivitiesCustomer;
